import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=4cdef5bd&"
import script from "./PreviewFile.vue?vue&type=script&lang=ts&"
export * from "./PreviewFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports